//läheb alla kuni leiab

const routes = [
  { 
    path: '/', 
    component: () => import('layouts/AffiliateLayout.vue'),
    children: [
      {
        path: '/terms-and-conditions',
        name: 'terms',
        component: () => import('pages/Terms.vue'),
        meta: { 
          auth: false
        }
      },
      {
        path: '',
        name: 'aff_overview',
        component: () => import('pages/Overview.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/settings',
        name: 'aff_settings',
        component: () => import('pages/Settings.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/campaigns',
        name: 'aff_campaigns',
        component: () => import('pages/CampaignsList.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/campaigns/:id',
        name: 'aff_campaign',
        component: () => import('pages/Campaign.vue'),
        meta: {
          auth: true,
        }
      },
//      {
//        path: '/sell-apis',
//        name: 'api_sales',
//        component: () => import('pages/ApiSales.vue'),
//        meta: {
//          auth: true,
//        }
//      },
      {
        path: '/auth/login',
        name: 'login',
        component: () => import('pages/auth/Login.vue')
      },
      {
        path: '/auth/verify',
        name: 'verify',
        component: () => import('pages/auth/Verify.vue')
      },
      {
        path: '/performance/daily',
        name: 'aff_performance_daily',
        component: () => import('pages/PerformanceDaily.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/performance/conversions',
        name: 'aff_performance_conversions',
        component: () => import('pages/PerformanceConversions.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/accounting',
        name: 'aff_accounting',
        component: () => import('pages/Accounting.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/users',
        name: 'aff_users',
        component: () => import('pages/UserList.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/notifications',
        name: 'aff_notifications',
        component: () => import('pages/Notifications.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/apiconfig',
        name: 'aff_apis',
        component: () => import('pages/ApiConfiguration.vue'),
        meta: {
          auth: true,
        }
      },
      {
        path: '/company/details',
        name: 'aff_info',
        component: () => import('pages/Info.vue'),
        meta: {
          auth: false,
        }
      },
    ]
  }
];

export default routes;
